var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cTable',{attrs:{"fields":_vm.fields,"methods":_vm.methods,"modals":_vm.modals,"config":_vm.config,"header":_vm.header,"footer":_vm.footer},scopedSlots:_vm._u([{key:"FLOW",fn:function(){return [_vm._v(" add ")]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }